export class MessageError extends Error {
  constructor(message, code) {
    super(message); // 调用父类的构造函数
    this.name = this.constructor.name; // 设置name属性为类名
    this.code = code; // 设置code属性
    Error.captureStackTrace(this, this.constructor); // 设置堆栈跟踪
  }
}

